var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-3" },
    [
      _c(
        "b-card",
        { attrs: { title: "Edit Kuota Poli" } },
        [
          _c("b-card-text", [
            _c("p", { staticClass: "mt-3" }, [_vm._v("Notes:")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                - Jadwal dokter dan kuota poli yang bisa ditambah atau dirubah adalah jadwal dokter dan kuota poli hanya untuk pasien kategori Umum (jadwal dokter internal) saja"
              ),
              _c("br"),
              _vm._v(
                "\n                - Untuk penambahan dan perubahan jadwal dokter dan kuota poli untuk kategori BPJS silahkan melakukan perubahan di HFIS karena akan berpengaruh pada pembuatan SEP\n            "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-3" },
              [
                _c(
                  "b-button",
                  {
                    attrs: { variant: "primary", size: "sm" },
                    on: { click: _vm.addJadwalUmum },
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus" }),
                    _vm._v(" Tambah Jadwal Dokter Umum"),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    attrs: { variant: "primary", size: "sm" },
                    on: { click: _vm.updateJadwalDokterBPJS },
                  },
                  [
                    _c("i", { staticClass: "fa fa-refresh" }),
                    _vm._v(" Update Jdwal Dokter BPJS"),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    attrs: { variant: "danger", size: "sm" },
                    on: { click: _vm.cancelEdit },
                  },
                  [_vm._v("Kembali")]
                ),
                _vm._v(" "),
                _vm.add_new
                  ? _c(
                      "b-form",
                      { staticClass: "mt-3" },
                      [
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { md: "6" } }, [
                              _c("div", { staticClass: "row mb-3" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "col-sm-4 col-form-label text-end",
                                    attrs: { for: "nama_dokter" },
                                  },
                                  [_vm._v("Nama Dokter")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col" },
                                  [
                                    _c("select2", {
                                      staticClass: "form-input",
                                      attrs: {
                                        options: _vm.dokter_poli_options,
                                      },
                                      model: {
                                        value: _vm.form_data.kode_dokter,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form_data,
                                            "kode_dokter",
                                            $$v
                                          )
                                        },
                                        expression: "form_data.kode_dokter",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { md: "6" } }, [
                              _c("div", { staticClass: "row mb-3" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "col-sm-4 col-form-label text-end",
                                    attrs: { for: "hari" },
                                  },
                                  [_vm._v("Hari")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col" },
                                  [
                                    _c("select2", {
                                      staticClass: "form-input",
                                      attrs: { options: _vm.hari_options },
                                      model: {
                                        value: _vm.form_data.hari,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form_data, "hari", $$v)
                                        },
                                        expression: "form_data.hari",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { md: "6" } }, [
                              _c("div", { staticClass: "row mb-3" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "col-sm-4 col-form-label text-end",
                                    attrs: { for: "kapasitas_pasien" },
                                  },
                                  [_vm._v("Kapasitas Pasien")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col" },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        type: "number",
                                        id: "kapasitas_pasien",
                                      },
                                      model: {
                                        value: _vm.form_data.kapasitas_pasien,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form_data,
                                            "kapasitas_pasien",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form_data.kapasitas_pasien",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { md: "6" } }, [
                              _c("div", { staticClass: "row mb-3" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "col-sm-4 col-form-label text-end",
                                    attrs: { for: "jam_mulai" },
                                  },
                                  [_vm._v("Jam Mulai")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col" },
                                  [
                                    _c("b-form-input", {
                                      attrs: { id: "jam_mulai" },
                                      model: {
                                        value: _vm.form_data.jam_mulai,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form_data,
                                            "jam_mulai",
                                            $$v
                                          )
                                        },
                                        expression: "form_data.jam_mulai",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { md: "6" } }, [
                              _c("div", { staticClass: "row mb-3" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "col-sm-4 col-form-label text-end",
                                    attrs: { for: "jam_selesai" },
                                  },
                                  [_vm._v("Jam Selesai")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col" },
                                  [
                                    _c("b-form-input", {
                                      attrs: { id: "jam_selesai" },
                                      model: {
                                        value: _vm.form_data.jam_selesai,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form_data,
                                            "jam_selesai",
                                            $$v
                                          )
                                        },
                                        expression: "form_data.jam_selesai",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "6" } },
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c("b-col", { attrs: { sm: "4" } }),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            attrs: { variant: "success" },
                                            on: { click: _vm.simpanData },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-save",
                                            }),
                                            _vm._v(" Simpan"),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-button",
                                          {
                                            attrs: { variant: "danger" },
                                            on: { click: _vm.batalTambah },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-close",
                                            }),
                                            _vm._v(" Batal"),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("form", [
              _c("div", { staticClass: "row" }, [
                _c("div", {
                  staticClass: "mt-3",
                  attrs: { id: "tabledata-kuota-poli" },
                }),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }